import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import Spiner from '../../spiner/Spiner'
import Button from '../button/Button'

function ButtonWithSpiner({
  buttonContent,
  isLoading,
  reversed,
  className,
  small,
  ...rest
}) {
  return (
    <Button
      className={classNames(className)}
      outline={reversed}
      small={small}
      {...rest}
      disabled={isLoading}
    >
      {isLoading ? <Spiner {...{ reversed }} /> : buttonContent}
    </Button>
  )
}

ButtonWithSpiner.propTypes = {
  buttonContent: PropTypes.node.isRequired,
  isLoading: PropTypes.bool.isRequired,
  reversed: PropTypes.bool,
  small: PropTypes.bool,
  className: PropTypes.string,
}

export default ButtonWithSpiner
